import * as React from "react";
import TextField from "@mui/material/TextField";
import engb from "date-fns/locale/en-gb";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { DatePicker, DesktopDateTimePicker } from "@mui/x-date-pickers";
import { useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { size } from "lodash";

const MuiDate = ({
  sx,
  label,
  onChange,
  maxdate = "",
  mindate = "",
  defaultValue,
}) => {
  // console.log(onchange,"onchange");
  // const initialDate = value instanceof Date ? value : new Date(value);

  const [date, setDate] = useState(
    size(defaultValue) > 0 ? defaultValue : null
  );
  // console.log(mindate, maxdate, "Datesss");
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        sx={sx}
        label={label}
        minDate={mindate}
        maxDate={maxdate}
        inputRef={{ maxDate: { maxdate }, minDate: { mindate } }}
        value={date}
        // disablePast
        // disableFuture
        format="DD/MM/YYYY"
        onChange={(newValue) => {
          setDate(newValue); // Update local state
          onChange(newValue); // Call parent component's onChange function
        }}
      />
    </LocalizationProvider>
  );
};

export default MuiDate;
